import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
    accountName: Yup.string()
        .required('Required'),
    accountBalance: Yup.number()
        .required('Required'),
    accountCategory: Yup.object()
        .shape({
            label: Yup.string(),
            value: Yup.string().required().notOneOf(['0']),
        })
        .required('Required'),
    profileUUID: Yup.string()
        .required('Required'),
});

export default validationSchema;